<script setup lang="ts">
import { onLaunch, onShow, onHide } from '@dcloudio/uni-app'
import { useUserStore, useWsStore } from '@/store/index'
// import checkUpdate from '@/uni_modules/uni-upgrade-center-app/utils/check-update'
import app_upgrade from '@/utils/app-upgrade/js_sdk/index'
onLaunch(() => {
  console.log('App Launch')
  const userStore = useUserStore()
  const wsStore = useWsStore()
  if (!wsStore.socketTask && userStore.deviceInfo && userStore.shopInfo) {
    wsStore.url = `${import.meta.env.VITE_WS_URL}/websocket/connect/kds_${userStore.shopInfo.shopId}_${userStore.deviceInfo.printerId}_1`
    wsStore.init()
  }



















})
// onShow(() => {
//   console.log('App Show')
// })
// onHide(() => {
//   console.log('App Hide')
// })
</script>

<style lang="scss">
/* stylelint-disable selector-type-no-unknown */
button::after {
  border: none;
}

swiper,
scroll-view {
  flex: 1;
  height: 100%;
  overflow: hidden;
}

image {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}

// 单行省略，优先使用 unocss: text-ellipsis
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// 两行省略
.ellipsis-2 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

// 三行省略
.ellipsis-3 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
